import { __ } from "@wordpress/i18n";
import { useBlockProps, InspectorControls } from "@wordpress/block-editor";
import {
	Panel,
	PanelBody,
	RangeControl,
	ToggleControl,
	TextControl,
} from "@wordpress/components";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit(props) {
	const { attributes, setAttributes } = props;

	function setOption(key, value) {
		setAttributes({ [key]: value });
	}

	return (
		<div {...useBlockProps()}>
			<InspectorControls key="setting">
				<Panel>
					<PanelBody
						title={__("Circle Text Path Settings", "wpopus")}
						initialOpen={true}
					>
						<fieldset>
							<TextControl
								__nextHasNoMarginBottom
								__next40pxDefaultSize
								label={__("Text for Circular Path", "wpopus")}
								value={attributes.circleText}
								onChange={(newValue) => {
									setOption("circleText", newValue);
								}}
							/>
						</fieldset>

						<br />
						<fieldset>
							<RangeControl
								__nextHasNoMarginBottom
								__next40pxDefaultSize
								label={__("Size (px)", "wpopus")}
								value={attributes.circleTextSize}
								onChange={(newValue) => {
									setOption("circleTextSize", parseInt(newValue));
								}}
								min={100}
								step={10}
								max={500}
							/>
						</fieldset>

						<br />
						<fieldset>
							<ToggleControl
								__nextHasNoMarginBottom
								label={__("Enable Rotation", "wpopus")}
								help={__("Works only on the frontend.", "wpopus")}
								checked={attributes.circleTextRotate}
								onChange={(newValue) => {
									setOption("circleTextRotate", newValue);
								}}
							/>
						</fieldset>
					</PanelBody>
				</Panel>
			</InspectorControls>

			<div
				className="wpopus-circle-text-path-wrapper"
				style={{
					"--wpopus-circle-text-size": `${attributes.circleTextSize}px`,
				}}
			>
				<svg viewBox="0 0 200 200">
					<defs>
						<path
							id="circle"
							d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
						/>
					</defs>
					<text textAnchor="middle">
						<textPath href="#circle" startOffset="50%">
							{attributes.circleText}
						</textPath>
					</text>
				</svg>
			</div>
		</div>
	);
}
